import React from 'react';
import formatNumber from "../../helpers/NumberFormat";
import { useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa6";
import "./HomeClientNew.scss"

export default function LastMovements({ main }) {
  const navigate = useNavigate();
  const transactions = main?.user?.transactions || [];

  const twoNewestIncomingTxs = (transactions ?? [])
    .filter(tx => tx.type === 'in' && tx.status?.name === 'Received')
    .sort((a, b) => new Date(b.execution_date) - new Date(a.execution_date))
    .slice(0, 2);

  return (
    <div className="last-movements card-section next-payments-box d-flex flex-column" style={{ borderBottom: "2px solid #EFEFEF" }}>
      <h5>Last Movements - Incoming</h5>
      <div className="card-section mt-2" style={{ height: '100px' }}>
        <div className="border-new w-100">
          <div>
            <h5>{main?.user?.first_name} {main?.user?.last_name}</h5>
          </div>
          <div>
            <span className="account-number"> Current Account: {main?.user?.detail?.account_number?.replace(/^.*?-/, '')}</span>
          </div>
        </div>
      </div>
      <table className="table table-xxl mt-2 border">
        <thead>
          <tr className='table-head py-4'>
            <th>Description</th>
            <th>Amount</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {twoNewestIncomingTxs.length > 0 ? (
            twoNewestIncomingTxs.map((el, idx) => {
              const formattedDate = new Date(el.execution_date).toLocaleDateString("en-GB");
              return (
                <tr key={idx}>
                  <td>Depos. transfer</td>
                  <td>{formatNumber(el.amount)} EUR</td>
                  <td>{formattedDate}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="3" className="text-center">There are no current transactions</td>
            </tr>
          )}

        </tbody>
      </table>

      <div className='homeLinks mt-auto mt-5'>
        <a onClick={() => navigate('/balance-and-movements')}>VIEW ALL TRANSACTIONS <FaAngleRight /></a>
      </div>
    </div>
  );
}
